import React, { useEffect, useState } from "react";
import { IconButton, HStack, Text, Button, useToast } from "@chakra-ui/react";
import { LockIcon } from "@chakra-ui/icons";
import { authConfig, getUserInfo, ClientPrincipal, AUTHORIZED_EMAIL } from "../authConfig";

const AuthButton: React.FC = () => {
  const [user, setUser] = useState<ClientPrincipal | null>(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const toast = useToast();

  useEffect(() => {
    const fetchUser = async () => {
      const userInfo = await getUserInfo();
      setUser(userInfo);
      
      // Check if user is admin
      if (userInfo && userInfo.userDetails === AUTHORIZED_EMAIL) {
        setIsAdmin(true);
      }
      
      setLoading(false);
    };
    fetchUser();
  }, [toast]);

  const handleLogin = () => {
    window.location.href = `${authConfig.loginUrl}?post_login_redirect_uri=${encodeURIComponent(window.location.pathname)}&prompt=select_account`;
  };

  const handleLogout = () => {
    window.location.href = `${authConfig.logoutUrl}?post_logout_redirect_uri=${encodeURIComponent("/")}`;
  };

  if (loading) {
    return null;
  }

  // Only show auth button for admin user
  if (user && isAdmin) {
    return (
      <HStack spacing={3}>
        <Text fontSize="sm" color="gray.400" display={{ base: "none", md: "block" }}>
          {user.userDetails}
        </Text>
        <Button size="sm" variant="outline" colorScheme="gray" onClick={handleLogout}>
          Logout
        </Button>
      </HStack>
    );
  }

  // Show login button only (for admin access)
  return (
    <IconButton
      aria-label="Login Admin"
      icon={<LockIcon />}
      size="sm"
      variant="ghost"
      colorScheme="gray"
      onClick={handleLogin}
    />
  );
};

export default AuthButton;
